import $ from 'jquery'

export function ajax(url){

   const data = {
      url: url,
      action: 'dk_proxy',
      _ajax_nonce: dk_script_ajax_object.ajax_nonce,
   }

   return $.ajax({
      url: dk_script_ajax_object.ajax_url,
      method: 'post',
      dataType: "json",
      data: data
   });
}
